import { Layout } from '@/components/layout/Layout';
import { SEOHead } from '@/components/SEOHead';
import { HeroSection } from '@/components/sections/HeroSection';
import { ConsultingPreview } from '@/components/sections/ConsultingPreview';
import { ServicesPreview } from '@/components/sections/ServicesPreview';
import { KiAuditorBrandBanner } from '@/components/sections/KiAuditorBrandBanner';
import { AboutPreview } from '@/components/sections/AboutPreview';
import { SustainabilityPreview } from '@/components/sections/SustainabilityPreview';
import { CTASection } from '@/components/sections/CTASection';
import { getOrganizationJsonLd, getFaqJsonLd, getWebSiteJsonLd } from '@/lib/seo-constants';
import { useLang } from '@/lib/i18n';

const Index = () => {
  const lang = useLang();
  const faqs =
    lang === 'en'
      ? [
          { question: 'What does FERNAU Präzisionstechnik manufacture?', answer: 'FERNAU produces high-precision CNC turned and milled parts, assemblies and CAD/CAM design. Materials: steel, stainless steel, aluminium, titanium, plastics and more.' },
          { question: 'Where is FERNAU Präzisionstechnik located?', answer: 'FERNAU Präzisionstechnik GmbH is located at Merianstraße 5a, 64291 Darmstadt, Hesse, Germany.' },
          { question: 'Is FERNAU ISO certified?', answer: 'Yes, FERNAU Präzisionstechnik is certified to DIN EN ISO 9001:2015.' },
          { question: 'Which industries does FERNAU serve?', answer: 'FERNAU supplies mechanical engineering, medical technology, metrology, aerospace, automotive and energy industries.' },
        ]
      : [
          { question: 'Was fertigt FERNAU Präzisionstechnik?', answer: 'FERNAU fertigt hochpräzise CNC-Dreh- und Frästeile, Baugruppen und bietet CAD/CAM-Konstruktion. Materialien: Stahl, Edelstahl, Aluminium, Titan, Kunststoffe u.v.m.' },
          { question: 'Wo befindet sich FERNAU Präzisionstechnik?', answer: 'FERNAU Präzisionstechnik GmbH befindet sich in der Merianstraße 5a, 64291 Darmstadt, Hessen.' },
          { question: 'Ist FERNAU ISO-zertifiziert?', answer: 'Ja, FERNAU Präzisionstechnik ist nach DIN EN ISO 9001:2015 zertifiziert.' },
          { question: 'Welche Branchen beliefert FERNAU?', answer: 'FERNAU beliefert Maschinenbau, Medizintechnik, Messtechnik, Luftfahrt, Automotive und Energietechnik.' },
        ];
  const jsonLd = [
    getOrganizationJsonLd(lang),
    getWebSiteJsonLd(lang),
    getFaqJsonLd(faqs, lang),
  ];

  return (
    <Layout>
      <SEOHead
        title={{
          de: 'FERNAU Präzisionstechnik GmbH | CNC-Drehen & Fräsen Darmstadt',
          en: 'FERNAU | Precision CNC Machining near Frankfurt, Germany',
        }}
        description={{
          de: 'Ihr Partner für hochpräzise CNC-Zerspanung seit 1995. Drehen, Fräsen, Baugruppen – ISO 9001 zertifiziert. Maschinenbau, Medizintechnik, Messtechnik.',
          en: 'High-precision CNC turning, milling and assemblies near Frankfurt am Main. ISO 9001 certified Mittelstand manufacturer in Darmstadt / Rhine-Main, Germany since 1995.',
        }}
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ServicesPreview />
      <ConsultingPreview />
      <KiAuditorBrandBanner />
      <AboutPreview />
      <SustainabilityPreview />
      <CTASection />
    </Layout>
  );
};

export default Index;
